export default __webpack_public_path__ + "LS-light-(2).svg";